"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_table_1 = require("react-table");
var Table_styled_1 = require("./Table.styled");
var Table = function (_a) {
    var columns = _a.columns, data = _a.data, renderRowSubComponent = _a.renderRowSubComponent;
    var defaultColumn = react_1.default.useMemo(function () { return ({
        // Let's set up our default Filter UI
        Filter: function () {
            return null;
        },
    }); }, []);
    var _b = react_table_1.useTable({
        // @ts-ignore
        columns: columns,
        data: data,
        // @ts-ignore
        defaultColumn: defaultColumn,
    }, react_table_1.useFilters, react_table_1.useSortBy, react_table_1.useExpanded), getTableProps = _b.getTableProps, getTableBodyProps = _b.getTableBodyProps, headerGroups = _b.headerGroups, rows = _b.rows, prepareRow = _b.prepareRow;
    if (!data.length) {
        return null;
    }
    // const firstPageRows = rows.slice(0, 20)
    return (react_1.default.createElement(Table_styled_1.StyledTable, __assign({}, getTableProps()),
        react_1.default.createElement("thead", null, headerGroups.map(function (headerGroup) { return (react_1.default.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) {
            // Add the sorting props to control sorting. For this example
            // we can add them into the header props
            var headerProps = column.getHeaderProps(column.getSortByToggleProps());
            if (column.canFilter) {
                headerProps = column.getHeaderProps();
            }
            return (react_1.default.createElement("th", __assign({}, headerProps),
                column.canFilter ? column.render('Filter') : column.render('Header'),
                column.isSorted ? column.isSortedDesc ? react_1.default.createElement(Table_styled_1.CaretDown, null) : react_1.default.createElement(Table_styled_1.CaretUp, null) : ''));
        }))); })),
        react_1.default.createElement("tbody", __assign({}, getTableBodyProps()), rows.map(function (row, i) {
            prepareRow(row);
            return (react_1.default.createElement(react_1.default.Fragment, { key: i },
                react_1.default.createElement("tr", __assign({}, row.getRowProps()), row.cells.map(function (cell, indx) {
                    return (react_1.default.createElement("td", __assign({}, cell.getCellProps(), { key: indx }), cell.render('Cell')));
                })),
                row.isExpanded && renderRowSubComponent ? react_1.default.createElement(react_1.default.Fragment, null, renderRowSubComponent({ row: row })) : null));
        }))));
};
exports.default = Table;
